// extracted by mini-css-extract-plugin
export default {"container":"SummaryLineItem_container__OU+lJ","largeText":"SummaryLineItem_largeText__ApCA9"};